import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';

export async function favorite( id ) {
	const result = await apiFetch(
		{
			path: '/aspen-institute/v1/favorites',
			method: 'POST',
			body: JSON.stringify( { id } ),
			headers: {
				'Content-Type': 'application/json',
				'Accept'      : 'application/json',
			},
		}
	);

	return result;
}

export async function unfavorite( id ) {
	const result = await apiFetch(
		{
			path: `/aspen-institute/v1/favorites/${id}`,
			method: 'DELETE',
			headers: {
				'Accept': 'application/json',
			},
		},
	);

	return result;
}

export async function toggle( node ) {
	if ( node.dataset.id ) {
		let result;

		node.classList.add( 'is-loading' );

		try {
			const textOn  = node.querySelector( '.favorite__on' );
			const textOff = node.querySelector( '.favorite__off' );

			if ( node.dataset.state ) {
				result = await unfavorite( node.dataset.id );
				node.dataset.state = '';

				if ( textOff ) {
					node.title = textOff.textContent;
				}
			} else {
				result = await favorite( node.dataset.id );
				node.dataset.state = '1';

				if ( textOn ) {
					node.title = textOn.textContent;
				}
			}
		} catch ( error ) {
			console.error( error );
		} finally {
			node.classList.remove( 'is-loading' );
		}

		return result;
	}

	return false;
}

export async function query( params = {}, headers = {} ) {
	const fetchParams = {
		method: 'GET',
		path: addQueryArgs( 'aspen-institute/v1/favorites', params ),
		headers: {
			'Accept': 'application/json',
			...headers
		},
	};

	return apiFetch( fetchParams );
}

function listen( e ) {
	let target = e.target;

	while ( target && target.parentNode ) {
		if ( target.matches( 'button.favorite[data-id]' ) ) {
			e.preventDefault();
			toggle( target );
			return;
		}

		target = target.parentNode;
	}
}

document.addEventListener( 'click', listen );
